module.exports = __webpack_public_path__ + "static/media/bg50.c3fb389b.png";